import WebApp from "@twa-dev/sdk";

export function webAppDownloadFile(filename: string, url: string): void {
  if (WebApp.platform === "tdesktop") {
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else {
    WebApp.downloadFile({
      url,
      file_name: filename,
    });
  }
}
